// Modules
import React from 'react'
import { ArrowRight, ArrowLeft, MagnifyingGlass  } from '@phosphor-icons/react'
import LogoWhite from "../../../images/Telecel-Icon-White.png";

// Components
// import Carousel from './OwlCarousel'
import Button from '../../interface/Button/index.jsx'
import { navigate } from 'gatsby'
const Carousel = React.lazy(() =>
  import("./Carousel.js")
)

// Model: Banner
function HomeBanner ({ bannerContent }) {
  // Data
  const isSSR = typeof window === "undefined"

  // Render
  if (!bannerContent || bannerContent?.length < 1) return null
  return (
    <div className='min-h-121 lg:min-h-140 md:min-h-100'>
      {!isSSR && (
        <React.Suspense fallback={<BannerTemplate />}>
          <div data-component="banner min-h-111 lg:min-h-130 md:min-h-100 w-screen">
            <div className={`banner-wrapper ${bannerContent?.length === 1 && 'one-banner'}`}>
                <Carousel bannerContent={bannerContent}>
                  {bannerContent.map(banner =>
                    <div
                      key={banner.id}
                      className={`container w-screen min-h-111 lg:min-h-130 md:min-h-100 md:h-full flex-shrink-0 flex-grow object-cover relative !overflow-hidden`}>
                        <div className={`min-h-111 lg:min-h-130 md:min-h-100 h-full w-full ${banner?.transparentImage && 'banner '} ${banner.className}`}>
                            
                          {!!banner.title &&
                            <div className='absolute left-5 right-5 flex flex-col md:flex-row min-h-111 lg:min-h-130 md:min-h-100 h-full'>
                              <div className={`flex rounded-lg flex-col md:w-1/2 justify-start md:justify-center pt-11 px-7 h-full md:pl-13 md:py-5
                                ${!banner.backgroundImage && !banner.transparentImage && 'bg-black items-center md:pr-13 !w-full'}
                                ${!banner.transparentImage && 'justify-center items-center md:items-start pb-11'}
                                ${banner.overlay && 'bg-black h-full bg-opacity-50 md:bg-opacity-0 md:bg-gradient-to-r from-black to-transparent'}
                                ${banner.overlay && banner.transparentImage && 'bg-black !bg-opacity-0 bg-gradient-to-b from-black to-transparent !h-auto'}
                              `} >
                                {!!banner.title && <p className={`text-telecel_white break-words hyphens-auto text-center md:text-left text-heading_xl md:text-display_sm font-black  ${!banner.backgroundImage && !banner.transparentImage && 'w-full md:text-center' }`}>{banner.title}</p>}
                                {!!banner.description && <p className={`text-telecel_white text-center md:text-left px-6 md:px-0 mt-2 text-body_sm font-medium md:text-body_base md:w-4/5 ${!banner.backgroundImage && !banner.transparentImage && 'w-full md:text-center' }`}>{banner.description}</p>}
                                {!!banner.buttonText &&
                                  <Button
                                    styles={`rounded-full w-fit text-body_sm md:text-body_base  ${ banner.isRevervseButton ? "bg-telecel_white hover:bg-border_lighter text-brand" : "bg-brand hover:bg-red_600 text-telecel_white "} md:py-5 py-4 px-5 md:px-8 mt-7 mx-auto md:mx-0`}
                                    onClick={()=>navigate(banner.buttonAction)}>
                                    <span className="flex gap-2 items-center">{banner.buttonText}<ArrowRight size={25} /></span>
                                  </Button>
                                }
                                {!!banner.inputPlaceholder &&
                                  <form
                                    className="rounded-lg text-body_base md:text-body_lg bg-telecel_white text-black flex items-center md:py-2 py-2 px-4 mt-8 mx-auto md:mx-0 w-4/5"
                                    onClick={banner.buttonAction}>
                                    <input
                                      className='w-full text-black outline-none py-2'
                                      placeholder={banner.inputPlaceholder} />
                                    <button
                                      type='submit'>
                                      <MagnifyingGlass color='black' />
                                    </button>
                                  </form>
                                }
                              </div> 
                              {
                                banner.backgroundImage && banner?.transparentImage &&
                                <img src={banner.backgroundImage}
                                  alt="img"
                                  className="banner-image max-h-70 md:w-1/2 md:max-h-full !rounded-lg object-contain"
                                  draggable="false" />
                                }
                            </div>
                          }
                          {banner.backButton &&
                            <div className='absolute top-5 left-5'>
                              <Button
                                styles="rounded-full w-fit text-body_sm md:text-body_base bg-telecel_white hover:bg-border_lighter text-brand md:py-4 py-3 px-5 md:px-8 ml-7"
                                onClick={banner.buttonAction}>
                                <span className="flex gap-2 items-center"> <ArrowLeft size={25} />{banner.buttonText}</span>
                              </Button>
                            </div>
                          }

                          {
                            banner.backgroundImage && !banner.transparentImage &&
                            <img src={banner.backgroundImage}
                              alt="img"
                              className="w-full h-full  min-h-111 !rounded-lg object-cover"
                              draggable="false" />
                            }
                      </div>
                    </div>
                  )}
                </Carousel>
            </div>
          </div>
        </React.Suspense>
      )}
    </div>
  )
}

// Export



// function
function BannerTemplate () {
  return(
    <div data-component="banner min-h-111 lg:min-h-130 md:min-h-100 w-screen">
            <div className="">
                    <div
                      className={`container mx-auto w-screen min-h-111 lg:min-h-130 md:min-h-100 md:h-full flex-shrink-0 flex-grow object-cover relative !overflow-hidden`}>
                        <div className={`min-h-111 lg:min-h-130 md:min-h-100 h-full w-full homepage-banner-1`}>
                            
                            <div className='absolute left-5 right-5 flex flex-col md:flex-row min-h-111 lg:min-h-130 md:min-h-100 h-full'>
                              <div className={`flex rounded-lg flex-col md:w-1/2 justify-start md:justify-center pt-11 px-7 md:pl-13 md:py-5 bg-black bg-opacity-0 md:bg-gradient-to-r bg-gradient-to-b from-black to-transparent !h-auto'}`} >
                                <p className={`text-telecel_white break-words hyphens-auto text-center md:text-left text-heading_xl md:text-display_sm font-black`}>Telecel is Here!</p>
                                  <Button
                                    styles={`rounded-full w-fit text-body_sm md:text-body_base bg-telecel_white hover:bg-border_lighter text-brand md:py-5 py-4 px-5 md:px-8 mt-7 mx-auto md:mx-0`}
                                    onClick={()=>{}}>
                                    <span className="flex gap-2 items-center">Learn More<ArrowRight size={25} /></span>
                                  </Button>
                                
                              </div> 
                                <img src={LogoWhite}
                                  alt="img"
                                  className="banner-image max-h-70 md:w-1/2 md:max-h-full !rounded-lg object-contain"
                                  draggable="false" />
                            </div>
                      </div>
                    </div>
            </div>
          </div>
  )
}

export default HomeBanner